import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Aggregation, BaseQueryInputColumnDescription, ColumnGroupingDescription, LuaQueryColumn, Projection, ProjectionColumnDescription, Transformation, XDataType, XProjectorClient } from '../../../XProjector/xprojector-client-service';
import { TextColumnConfig, TextWidgetConfig, TextWidgetQuery } from '../text-widget-config/text-widget-config-service';
import { GroupSelectionTypes, OutputDataType, WidgetConfig, WidgetInputParameter, WidgetPrQueryColumnConfig } from '../../widget-config-service';
import { LOGGERSERVICE, XprojLoggerService } from '../../../logger/xproj-logger-service';
import { XprojGroupSelectionComponent } from '../../../filters/group-selection/xproj-group-selection.component';
import { XprojProjectionFilterComponent } from '../../../filters/projection-filter/xproj-projection-filter.component';
import { XprojWidgetConfigComponent } from '../../widget-config/xproj-widget-config.component';
import { XprojWidgetService } from '../../xproj-widget-service';
import { ArrayUtils } from '../../../utils/array-utils-service';
import { TypedJSON } from 'typedjson';


@Component({
  selector: 'xproj-text-widget-query-config',
  templateUrl: './text-widget-query-config.component.html',
  styleUrls: ['./text-widget-query-config.component.scss']
})
export class XprojTextWidgetQueryConfigComponent implements OnInit {

  @ViewChild("projectionFilter", { read: XprojProjectionFilterComponent, static: false }) projectionFilter: XprojProjectionFilterComponent;
  @ViewChild("groupSelect", { read: XprojGroupSelectionComponent, static: false }) groupSelect: XprojGroupSelectionComponent;
  @ViewChild("widgetBaseConfig", { read: XprojWidgetConfigComponent, static: false }) widgetBaseConfig: XprojWidgetConfigComponent;


  @Input() widgetQuery: TextWidgetQuery;
  @Input() projections: Projection[] = [];
  @Input() inputParameters: WidgetInputParameter[];
  @Input() widgetConfig: TextWidgetConfig;
  @Input() widgets: WidgetConfig[];

  @Output() onQueryRemoved = new EventEmitter<TextWidgetQuery>();

  projection: Projection;
  columns: ProjectionColumnDescription[] = [];
  queryableSelectedGroup: string[] = [];
  selectedColumnConfig: any = null;
  preQueryColumnConfigs : { columnname : string, columnConfig : WidgetPrQueryColumnConfig }[] = [];

  Transformation = Transformation;
  Aggregation = Aggregation;
  OutputDataType = OutputDataType;
  GroupSelectionTypes = GroupSelectionTypes;
  XDataType = XDataType;

  constructor(
    @Inject(LOGGERSERVICE) private logger: XprojLoggerService,
    private xprojClient: XProjectorClient,
    private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    if (this.projections?.length == 0) {
      this.projections = await this.xprojClient.RequestListQueryableProjections(0, 10000);
    }

    this.projection = this.projections.find(p => p.projectionid == this.widgetQuery.ProjectionId);
    this.selectedProjectionGroupChange(this.widgetQuery.Query.targetgroup);
  }

  async selectedProjectionChange(projection: Projection) {
    if (projection) {
      this.widgetQuery.Query.targetgroup = null;
      this.queryableSelectedGroup.length = 0;
      await this.queryColumns(this.projection.projectionid, null);
    }
  }

  async selectedProjectionGroupChange(group: any) {
    if (this.projection) {
      this.widgetQuery.Query.targetgroup = group;
      this.queryableSelectedGroup.length = 0;
      for (let gr of group) {
        this.queryableSelectedGroup.push(gr);
      }
      //console.log('selectedProjectionGroupChange', group);
      await this.queryColumns(this.projection.projectionid, group);
    }
  }

  async queryColumns(projectionId: string, group: Array<string>) {
    let groupstr = "";
    if (group) {
      groupstr = group.join(",");
    }
    this.columns = await this.xprojClient.RequestListQueryableProjectionColumns(projectionId, groupstr, 0, 500);

    this.preQueryColumnConfigs = [];
    this.widgetConfig.WidgetPreQueryConfigs.forEach(preConfig => {
      preConfig.ColumnConfigs.forEach(c => this.preQueryColumnConfigs.push({ columnname: (preConfig.Prefix?.length > 0 ? preConfig.Prefix : preConfig.Name) + ':' + c.ColumnOutName, columnConfig: c }));
    });
  }

  removeQuery() {
    this.onQueryRemoved?.emit(this.widgetQuery);
  }

  removeColumn(index: number) {
    ArrayUtils.RemoveItemAt(this.widgetQuery.ColumnConfigs, index);
  }

  moveColumnUp(index: number) {
    ArrayUtils.MoveItemUp(this.widgetQuery.ColumnConfigs, index);
    this.refreshColumnConfigs();
  }

  moveColumnDown(index: number) {
    ArrayUtils.MoveItemDown(this.widgetQuery.ColumnConfigs, index);
    this.refreshColumnConfigs();
  }

  private refreshColumnConfigs() {
    let copy = [...this.widgetQuery.ColumnConfigs];
    this.widgetQuery.ColumnConfigs = [];
    this.cdr.detectChanges();
    this.widgetQuery.ColumnConfigs = copy;
  }

  removeSelectedColumn() {
    let counter = 0;
    for (let i of this.widgetQuery.ColumnConfigs) {
      if (i == this.selectedColumnConfig)
        break;
      counter++;
    }
    this.removeColumn(counter);
    this.selectedColumnConfig = null;

  }

  onColumnSelect($event, index) {
    let column = this.columns.find(col => col.columnname == $event);
    if (column && column.unit?.length > 0 && index < this.widgetQuery.ColumnConfigs.length) {
      this.widgetQuery.ColumnConfigs[index].Unit = column.unit;
    }
    if (column) {
      this.widgetQuery.ColumnConfigs[index].Datatype = column.datatype;
      this.widgetQuery.ColumnConfigs[index].Writeable = column.writable;
    }
    else {
      let column = this.preQueryColumnConfigs.find(col => col.columnname == $event);
      if (column) {
        this.widgetQuery.ColumnConfigs[index].Datatype = column.columnConfig.Datatype;
      }
      else {
        let column = this.widgetQuery.Scriptedcolumnspostaggregation.find(col => 'script:' + col.columnoutname == $event);
        if (column) {
          this.widgetQuery.ColumnConfigs[index].Datatype = column.datatypeout;
          if (this.widgetQuery.ColumnConfigs[index].Label.length == 0) {
            this.widgetQuery.ColumnConfigs[index].Label = column.columnoutname;
          }
        }
      }
    }

  }

  addAllColumns() {
    //this.queryData.columnConfigs.push(new ColumnConfig());

    for (let col of this.columns) {
      let t = new TextColumnConfig();
      t.ColumnName = col.columnname;
      t.ColumnOutName = col.columnname;
      t.Label = col.columnname;
      t.Datatype = col.datatype;
      t.Unit = col.unit;
      t.Writeable = col.writable;

      this.widgetQuery.ColumnConfigs.push(t);
    }

  }
  removeAllColumns() {
    this.widgetQuery.ColumnConfigs = [];
  }

  addColumn() {
    this.widgetQuery.ColumnConfigs.push(new TextColumnConfig());
  }

  addScriptedColumnsPostAggregation() {
    this.widgetQuery.Scriptedcolumnspostaggregation.push(new LuaQueryColumn());
  }

  onLuaQueryColumnRemoved(queryColumn: LuaQueryColumn) {
    this.widgetQuery.Scriptedcolumnspostaggregation = this.widgetQuery.Scriptedcolumnspostaggregation.filter(q => q != queryColumn);
  }

  async SaveQuery() {

    this.widgetQuery.DataFilters.forEach(filter => {
      filter.ColumnDescriptor = TypedJSON.parse(JSON.stringify(filter.ColumnDescriptor), ProjectionColumnDescription);
    });

    this.widgetQuery.Query = this.projectionFilter.GetQuery();
    this.widgetQuery.DataFilters = this.projectionFilter.datafilters;
    this.widgetQuery.FilterLogicalGroupType = this.projectionFilter.filterLogicalGroupType;
    this.widgetQuery.Query.maxitems = 1;
    this.widgetQuery.Query.scriptedcolumnspostaggregation = this.widgetQuery.Scriptedcolumnspostaggregation;

    this.widgetQuery.ProjectionId = this.projection?.projectionid;
    this.widgetQuery.Group = this.widgetQuery.Query.targetgroup;
    this.widgetQuery.Query.targetprojectionid = this.widgetQuery.ProjectionId;

    if (this.widgetQuery.ColumnConfigs.length > 0) {
      let colindex = 0;
      for (let column of this.widgetQuery.ColumnConfigs) {
        let col = new BaseQueryInputColumnDescription();
        col.columnname = column.ColumnName;
        if (column.Label?.length > 0) {
          col.columnoutname = column.ColumnOutName = column.Label;
        }
        else {
          col.columnoutname = column.ColumnOutName = column.ColumnName;
        }

        if (colindex == 0) {
          if (!this.widgetQuery.UseGrouping) {
            this.widgetQuery.Query.sorting.columnname = col.columnname;
            this.widgetQuery.Query.sorting.descending = false;
            this.widgetQuery.Query.grouping = new ColumnGroupingDescription();
            this.widgetQuery.Query.columns.push(col);
          }
          else {
            this.widgetQuery.Query.grouping.columnname = col.columnname;
            this.widgetQuery.Query.grouping.columntransformation = this.widgetQuery.GroupingTransform;
            this.widgetQuery.Query.grouping.columnoutname = col.columnoutname;
          }
        }
        else {
          if (this.widgetQuery.UseGrouping) {
            col.columnaggregation = column.Transform;
          }
          this.widgetQuery.Query.columns.push(col);
        }

        colindex++;
      }

      if (this.groupSelect) {
        this.widgetQuery.Query.targetgroup = this.groupSelect.getSelectedGroup();
      }
    }
  }
}
